export default function isAlphaNumeric(source: string): boolean {
  return /^[a-zA-Z0-9]*$/.exec(source) !== null;
}

export function isAlphaNumericInSpanish(source: string): boolean {
  return (
    /^[a-zA-Z0-9À-ÿ ]*$/.exec(source) !== null &&
    (source === '' || source.trim() !== '')
  );
}

export function isAlphaNumericForAddress(source: string): boolean {
  return (
    /^[a-zA-Z0-9À-ÿ .,;:'\\/()-]*$/.exec(source) !== null &&
    (source === '' || source.trim() !== '')
  );
}
